<!--指标成因路径分析表-->
<style lang="less" scoped>
    .chart {
        &-wrap {
            width: 100%;
            /*min-width: 1028px;*/
            white-space: nowrap;
            display: flex;
        }

        &-container {
            display: inline-block;
            vertical-align: top;
        }

        &-item {
            width: 100%;
            text-align: center;
        }

        &-tip {
            margin-top: 10px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            font-size: 12px;
            color: #464C5B;
        }
    }

    .card-box {
        &-wrap {
            width: 100%;
        }
        width: 100%;
        position: relative;
        display: inline-block;
        font-size: 0;

        &.middle-box {
            &:after {
                left: 18%;
                right: 18%;
            }
        }

        &:after {
            content: '';
            display: block;

            position: absolute;
            left: 10%;
            right: 10%;
            height: 8px;
            border: 1px solid rgba(219,222,231,1);
            border-top: 0;
        }

        &-noborder {
            &:after {
                display: none;
                content: '';
            }
        }

    }
    .mt25 {
        margin-top: 25px;
    }
    .icon {
        display: inline-block;
        /*background-color: red;*/
        vertical-align: top;
        height: 86px;
        width: 4%;
        max-width: 32px;

        background-repeat: no-repeat;
        background-size: 80%;
        background-position: center center;

        &-subtract {
            background-image: url("//m.360buyimg.com/img/jfs/t1/115091/5/11836/506/5f05a8b4Ef21698c7/4e7855b5b10012cc.png");
        }

        &-plus-card {
            background-image: url("//m.360buyimg.com/img/jfs/t1/137424/40/3989/573/5f05a8b4E94fbb708/179268dce53872ac.png");
        }
    }
</style>

<template>
    <div class="chart-wrap">
        <div class="chart-container" style="width: 50%;margin-left: -30px;">
            <div class="chart-item">
                <div class="card-box-wrap">
                    <div class="card-box">
                        <Card title="收入合计(含税)" :carddata="chartData[0]" :piedata="chartData[0] && chartData[0].pieData"></Card>
                        <div class="icon icon-subtract"></div>
                        <Card title="成本合计(含税)" :carddata="chartData[1]" :piedata="chartData[1] && chartData[1].pieData"></Card>
                    </div>
                </div>
                <div class="card-box-wrap">
                    <div class="card-box mt25 middle-box">
                    <Card title="毛利收入(含税)" :carddata="chartData[2]" :piedata="chartData[2] && chartData[2].pieData" topline :style="cardStyle" result-visible></Card>
                    <div class="icon icon-subtract"></div>
                    <Card title="税金及附加" :carddata="chartData[3]" :piedata="chartData[3] && chartData[3].pieData" :style="middleWidth"></Card>
                    </div>
                </div>
                <div class="card-box-wrap">
                    <div class="card-box mt25 middle-box">
                        <Card title="税后毛利合计" :carddata="chartData[4]" :piedata="chartData[4] && chartData[4].pieData" topline :style="cardStyle" result-visible></Card>
                        <div class="icon icon-subtract"></div>
                        <Card title="税后费用合计" :carddata="chartData[5]" :piedata="chartData[5] && chartData[5].pieData" :style="middleWidth"></Card>
                    </div>
                </div>
                <div class="card-box-wrap">
                <div class="card-box mt25 card-box-noborder">
                    <Card title="经营利润" :carddata="chartData[6]" :piedata="chartData[6] && chartData[6].pieData" topline :style="cardStyle" :chartvisible="false" result-visible></Card>
                </div>
            </div>
            </div>
        </div>
        <div class="chart-container" style="width: 50%">
            <div class="chart-item" style="margin-bottom: 25px">
                <div class="card-box-wrap">
                    <div class="card-box">
                        <Card title="税后成本合计" :carddata="chartData[7]" :piedata="chartData[7] && chartData[7].pieData"></Card>
                        <div class="icon icon-plus-card"></div>
                        <Card title="营销费" :carddata="chartData[8]" :piedata="chartData[8] && chartData[8].pieData" :style="minWidth" bottomline :chartvisible="false"></Card>
                        <div  class="icon icon-plus-card"></div>
                        <Card title="刷卡手续费" :carddata="chartData[9]" :piedata="chartData[9] && chartData[9].pieData" :style="minWidth" :chartvisible="false"></Card>
                    </div>
                </div>
                <div class="card-box-wrap">
                    <div class="card-box mt25 card-box-noborder">
                        <Card title="变动成本" :carddata="chartData[10]" :piedata="chartData[10] && chartData[10].pieData" topline :style="cardStyle" :chartvisible="false" result-visible></Card>
                    </div>
                </div>
            </div>
            <div class="chart-item">
                <div class="card-box-wrap">
                    <div class="card-box">
                        <Card title="税后费用合计" :carddata="chartData[11]" :piedata="chartData[11] && chartData[11].pieData"></Card>
                        <div class="icon icon-subtract"></div>
                        <Card title="营销费" :carddata="chartData[12]" :piedata="chartData[12] && chartData[12].pieData" bottomline :style="minWidth" :chartvisible="false"></Card>
                        <div class="icon icon-subtract"></div>
                        <Card title="刷卡手续费" :carddata="chartData[13]" :piedata="chartData[13] && chartData[13].pieData" :style="minWidth" :chartvisible="false"></Card>
                    </div>
                </div>
                <div class="card-box-wrap">
                    <div class="card-box mt25 card-box-noborder">
                        <Card title="固定成本" :carddata="chartData[14]" :piedata="chartData[14] && chartData[14].pieData" topline :style="cardStyle" :chartvisible="false" result-visible></Card>
                    </div>
                </div>
            </div>
<!--            <div class="chart-tip">(按税率扣除后)</div>-->
        </div>
    </div>
</template>

<script>
    import Card from './card'
    export default {
        name: "cause-chart",
        components: { Card },
        props: {
            chartData: {
                type: Array,
                default: function () {
                    return []
                }
            },
        },
        data() {
            return {
                middleWidth: {
                    width: '35%',
                },
                minWidth: {
                    width: '25%',
                },
                cardStyle: {
                    width: '35%',
                    backgroundColor: '#EDF6FF'
                }
            }
        },
        compiled () {
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// cause-chart.vue?d76d9f1c